export function loadSentry() {
  return import(/* webpackChunkName: "app-events" */ '@sentry/react');
}

export function loadSentryCli() {
  return import(/* webpackChunkName: "app-events-cli" */ './capture');
}
